import { fun_PostAction, fun_GetAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        personName: null // 项目负责人名称
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "姓名：",
          value: "personName",
          placeholder: "请输入",
          clearable: true
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "姓名",
          prop: "personName"
        },
        {
          label: "性别",
          prop: "sexNum",
          width: 80
        },
        {
          label: "核验状态",
          prop: "auditStateName"
        },
        // {
        //   label: "证件类型",
        //   prop: "idCardTypeName"
        // },
        // {
        //   label: "证件号码",
        //   prop: "idCard",
        //   width: 200
        // },
        {
          label: "出生日期",
          prop: "birthDay"
        },
        {
          label: "民族",
          prop: "nationlityName"
        },
        {
          label: "学历",
          prop: "eduLevelNum"
        },
        // {
        //   label: "手机号码",
        //   prop: "mobile"
        // }
      ],
      // 表格数据
      tableData: [],
      userFlag: null, // 用户标识
      userType: null, // 用户类型
      multipleSelection: [], // 勾选数组
      // 温馨提示
      tipList: [
        /*{
          type: "text",
          text: "“转入”和“转出”需要企业（市场主体）与项目负责人双方同意！",
        },*/
      ],
      // 全局加载
      fullLoading: null,
    };
  },
  // 注册组件
  components: {},

  // 模板编译完成
  mounted() {
    // 查询一览数据
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/regPersonBasicinfoChoose/unList", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    
    /**
     * 重置
     * @author 滕威
     */
     fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 转入
     */
    fun_Join() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 主键集合
        let keys = [];
        // 遍历勾选
        for (const index in this.multipleSelection) {
          // 赋值主键集合
          keys[index] = this.multipleSelection[index].id;
        }
        // 弹出询问confirm
        this.$confirm("确认要将此项目负责人转入？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 打开遮罩
          this.fun_Loading();
          // 请求，获取结果集
          fun_PostAction("/regPersonBasicinfoChoose/updateUnRegPerson", {
            keys: keys,
            controllerFlg: "insert"
          }).then(res => {
            // 加载框取消
            this.fullLoading.close();
            // 解构res.data
            const { msg } = res.data;
            // 操作成功
            this.$message.success(msg);
            // 刷新当前页面
            this.fun_GetList();
          })
          .catch(() => {
            // 加载框取消
            this.fullLoading.close();
          });
        });
      } else {
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 全局加载
     * @author liutong
     */
    fun_Loading(val) {
      this.fullLoading = this.$loading({
        lock: true,
        text: val ? val : "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$emit("fun_Back");
    }
  }
};
